import {observable} from 'mobx';

export class AcceptTermsModalState {
    @observable isVisible: boolean = false;
    @observable termsPath: string = '';
    @observable readOnly: boolean = false;
}
